import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { createUnit } from '../i18n/unitQtyWrapper';
import { LOCALE_GROUPS } from '../constants/units';
import { getMicrosoftGDDSelector } from './featureSelectors';
import { getCurrentSeason } from './seasonSelectors';

export const gduSelector = (state: AppState) => state.weather.gdus;

export const gduListSelector = createSelector(
  [gduSelector, getCurrentSeason, getMicrosoftGDDSelector],
  (gdus, currentSeason, useMicrosoftGDD) => {
    if (useMicrosoftGDD) {
      return gdus[currentSeason] ?? {};
    }

    return gdus;
  }
)

export const precipitationSelector = (state: AppState) => state.weather.precipitation;

export function gduValueForFHAEvent(gdus: Record<string, number | null>, { date }: { date: string }) {
  const gdu = gdus[date.split('T')[0]];

  if (!gdu) return null;

  const gdusLocalized = createUnit(gdu, 'gduc', 0).forLocaleGroup(LOCALE_GROUPS.CROP_HEAT_INDEX);

  return gdusLocalized.scalarLocaleString;
}
